import React, {Component} from "react";
import {Formik, Form} from "formik";
import {ClipLoader} from "react-spinners";
import swal from "sweetalert";
import {connect} from "react-redux";
import * as cpo from "../redux";
import { UncontrolledAlert } from 'reactstrap';


class CostPackageBySSOTReportComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            message_response: ''
        };
    }

    render() {
        return (
            <div>
                <div className="row">
                    {this.state.message_response && (
                        <div className="col-md-12">
                            <UncontrolledAlert color="info">
                                {this.state.message_response}
                            </UncontrolledAlert>
                        </div>
                    )}
                    <div className="col-md-12">
                        <Formik initialValues={{}} onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                return (
                                    <Form>
                                        <button type="submit" className="btn btn-success float-right">
                                            Download
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader/>
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {

        const errorMessage = () => {
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        };

        this.setState({isLoadig: true, message_response: ""});

        cpo.service.getCostPackageBySSOTReport({})
            .then(response => {
                this.setState({isLoadig: false, message_response: response.data.detail});
            })
            .catch(response => {
                this.setState({isLoadig: false});
                errorMessage();
            });
    };
}

const mapStateToProps = (store, ownProps) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CostPackageBySSOTReportComponent);
